/**
 * Phase 3 - English translations module (base locale)
 * Loaded dynamically. Merge: translations + plans.
 */
import { translationsEn } from '../../utils/translations/translations.en.js';
import { plansTranslationsEn } from '../../utils/translations/plans/plansTranslations.en.js';

const merged = { ...translationsEn, ...plansTranslationsEn };
export default merged;
